<template>
    <RecordingsList class="mt-3" :sessionId="sessionId" dark />
</template>

<script>
import RecordingsList from '@/components/RecordingsList';

export default {
    props: {
        sessionId: {type: String }
    },

    data() {
        return {
        };
    },

    components: {
        RecordingsList
    }
};
</script>